import { Box } from '@mui/material'
import React from 'react'
import ThinkingCard from './ThinkingCard'
import ThinkingCardImage01 from '../../assets/images/ThinkingCard.jpeg'


const ThinkingCardSection = () => {
  return (
    <Box sx={{
        display:"flex",
        flexWrap:"wrap",
        gap:"2rem",
        justifyContent:"space-between",
        maxWidth:{xs:"100%",sm:"100%",xl:"1440px"},
        padding:"1rem 3rem",
        margin:"0 auto",
    }} >
    <ThinkingCard ThinkingCardImage={ThinkingCardImage01} />
    </Box>
  )
}

export default ThinkingCardSection
